import * as React from 'react';
import { connect } from 'react-redux';
import * as FleetModule from 'Modules/FleetModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { withTranslation  } from 'react-i18next';
import { ParentDetails, CustomProps, IParentDetailsProps } from 'components/Layout/DetailsSidebar/ParentDetails';

interface IP extends IParentDetailsProps {
    history: any;
}
type ConnectedP = {
    fleetStore: FleetModule.Types.FleetStore;
};
type DispatchedP = {
    deleteFleet: (fleetId: number) => Function;
    setActiveFleet: (fleet: FleetModule.Types.CarFleetDto) => Function;
    showPopup: (popupData: ViewManagementModule.Types.Popup) => Function;
    t?: (key: string) => string;
};
type S = {};
class FleetListDetails extends ParentDetails<IP & ConnectedP & DispatchedP, S> {
    public getCustomProps(): CustomProps {
        const { PopupType } = ViewManagementModule.VMEnumTypes;
        const { fleetStore } = this.props;
        const {
            fleetStore: { activeFleetRowId }
        } = this.props;
        return {
            ...(this.props as any),
            setActiveEl: (el: any) => {
                return this.props.setActiveFleet(el);
            },
            deleteEl: () => {
                return this.props.deleteFleet(activeFleetRowId || null);
            },
            elStore: fleetStore,
            activeEl: activeFleetRowId,
            redirectUrlEdit: `/fleet/${activeFleetRowId ? activeFleetRowId : ''}`,
            redirectUrlAdd: '/fleet/add',
            popupTypeDelete: PopupType.DELETE_FLEET,
            labelAdd: this.props.t('addFleet'),
            labelEdit: this.props.t('edit'),
            labelDelete: this.props.t('delete')
        };
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        fleetStore: state.fleetStore
    };
}
function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        deleteFleet: fleetId => dispatch(FleetModule.Actions.deleteFleet(fleetId)),
        setActiveFleet: (fleet: FleetModule.Types.CarFleetDto) => dispatch(FleetModule.Actions.setActiveFleet(fleet)),
        showPopup: (popupData: ViewManagementModule.Types.Popup) => dispatch(ViewManagementModule.Actions.showPopup(popupData))
    };
}
export default withTranslation (['carDetails'])(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(FleetListDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/FleetListDetails.tsx